import apiService from '../apiService';

const OutgoingService = {
  listOutgoing: (params) => apiService.get('/outgoings', params),
  getOutgoing: (id) => apiService.get(`/outgoings/${id}`),
  createOutgoing: (data) => apiService.post('/outgoings', data),
  updateOutgoing: (id, data) => apiService.put(`/outgoings/${id}`, data),
  deleteOutgoing: (id) => apiService.delete(`/outgoings/${id}`),
};

export default OutgoingService;
